import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '../use-api';

import type { IAdherenceSettingCohortsInactiveDays } from 'infrastructure/interfaces';

const api = `core-2/adherence-settings/adherence-cohorts-inactive-days`;

export const useCreateCohortsInactiveDays = () => {
  const { createData } = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async (dataProps: IAdherenceSettingCohortsInactiveDays) =>
      createData(api, dataProps),
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetCohortsInactiveDays']);
    },
  });

  return {
    mutateAsync,
    isLoading,
  };
};
